import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch, useRouteMatch } from 'react-router-dom';

import { withMaintenanceCheck } from '@/hocs';
import { IdentificationUIState } from '@/model/identification/types';

import { withIdentificationStatusGuard } from './hocs';
import { ConfirmationPage, LoginPage } from './pages';

const DefaultRoute: React.FC<RouteComponentProps> = ({ location, match: { path } }: RouteComponentProps) => {
  console.warn(`URL not found: ${location.pathname}`);
  return <Redirect to={`${path}/${IdentificationUIState.LOGIN}`} />;
};

export const IdentificationPages: React.FC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/${IdentificationUIState.LOGIN}`} component={LoginPage} />
      <Route path={`${path}/${IdentificationUIState.CONFIRMATION}`} component={ConfirmationPage} />
      <Route component={DefaultRoute} />
    </Switch>
  );
};

export default withMaintenanceCheck('verificationDisabled')(withIdentificationStatusGuard(IdentificationPages));
